import makeFormRequest from "../../../../helpers/form-request.js";
import ServerResponse from "../../../../helpers/render-server-response.js";
import Request from "../../../../helpers/request.js";
import APP_COMPONENTS from "../components/index.js";
export default {
    execute: async (data) => {
        const { form, submitBtn } = data;
        const payload = {
            date: form.showdate.value,
            venue: form.venue.value.trim(),
            location: form.location.value.trim(),
            link: form.link.value.trim(),
            soldOut: form.soldout.checked
        };
        const formRequest = makeFormRequest({ form, submitBtn });
        const response = await Request.post('/shows/create', payload);
        formRequest.afterResponse(false);
        if (response.success) {
            ServerResponse.show({
                resp: response,
                respTitle: 'SUCCESS',
                respText: `Show added successfully.`
            });
            APP_COMPONENTS.showsForms.update(data.id, response.id);
            return;
        }
        ServerResponse.show({
            resp: response,
            respTitle: 'ERROR',
            respText: response.error
        });
    }
};
